var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowDiagonal = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  width: 55,
  height: 64,
  fill: "none",
  viewBox: "0 0 55 64"
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 5,
  d: "M2.91 3.5c11.5 0 27.524-2 36.867 7.726 18.11 18.852 6.358 40.796 3.19 47.383m-4.92-6.524 4.836 9.097 8.881-5.133"
})));
export { SvgArrowDiagonal as ReactComponent };